import { eBSKTDotHocActionsObj } from "../../action-types/category/IBSKTDotHocActions";
import { generateActions } from "../generateActions";

export const bsktDotHocActions = {
  ...generateActions(eBSKTDotHocActionsObj, "BSKT_DOT_HOC"),
};
